import React from 'react';
import classNames from 'classnames';
import { SML_SIZE } from '../constants/common';
var InputExternalLabel = function (_a) {
    var label = _a.label, _b = _a.className, className = _b === void 0 ? '' : _b, size = _a.size, required = _a.required;
    return label ? (React.createElement("p", { className: classNames("lfc-m-0 lfc-mb-[8px] ".concat(className), {
            'lfc-font-semibold lfc-text-gray-800 lfc-text-lg': size !== SML_SIZE.S,
            'lfc-font-semibold lfc-text-gray-800 lfc-text-base': size === SML_SIZE.S,
            'lfc-font-normal lfc-text-gray-600 lfc-text-sm': size === 'mini'
        }) },
        label,
        ' ',
        required && React.createElement("span", { className: 'lfc-text-[10px] lfc-text-red-600 lfc-ml-[2px] lfc-align-top' }, "\u2732"))) : null;
};
export default InputExternalLabel;
//# sourceMappingURL=InputExternalLabel.js.map